import React, { FC, useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { CheckCircleIcon } from '@heroicons/react/outline'
import { StyledReceiptView } from '.'
import { PageLayout, Heading } from '../System'
import { Cart } from '../Cart'
import ROUTES from '../utils/routes'
import { CartItemType } from '../../types'

const ReceiptView: FC = () => {
  const { state }: any = useLocation()
  const [purchasedItems, setPurchasedItems] = useState<CartItemType[]>([])
  const history = useHistory()

  useEffect(() => {
    if (!state?.items) {
      return history.push(ROUTES.dashboard.home)
    }

    setPurchasedItems(state.items)
  }, [state])

  return (
    <StyledReceiptView>
      <PageLayout maxWidth={700}>
        <Heading>
          <CheckCircleIcon /> Thank You
        </Heading>
        <Heading type="h2">Today Just Got Even Better!</Heading>
        <p>This is your purchase confirmation of:</p>
        <div className="cart-area">
          {purchasedItems.length > 0 && <Cart items={purchasedItems} isReceipt />}
        </div>
      </PageLayout>
    </StyledReceiptView>
  )
}

export default ReceiptView
